// extracted by css-extract-rspack-plugin
export default {"badge-button-wrapper":"sDjpMh","badgeButtonWrapper":"sDjpMh","badge-button":"TUmbCI","badgeButton":"TUmbCI","badge":"p8MujM"};